import { LocationType, Status, Urgency } from './types'

export const MOCK_LIEUX = [
  // --- Zones Communes / Services ---
  { id: 'Accueil', name: 'Accueil', type: LocationType.COMMON_ZONE },
  { id: 'Atelier_Tech', name: 'Atelier Technique', type: LocationType.COMMON_ZONE },
  { id: 'Atelier_Menage', name: 'Atelier Ménage', type: LocationType.COMMON_ZONE },
  { id: 'Laverie', name: 'Laverie', type: LocationType.EQUIPMENT },
  { id: 'Piscine', name: 'Piscine', type: LocationType.COMMON_ZONE },
  { id: 'Parking', name: 'Parking', type: LocationType.COMMON_ZONE },
  { id: 'Camping_Global', name: 'Camping Global', type: LocationType.COMMON_ZONE },

  // --- Loisirs ---
  { id: 'Aire_Sports', name: 'Aire de sports', type: LocationType.COMMON_ZONE },
  { id: 'Aire_Jeux', name: 'Aire de jeux', type: LocationType.COMMON_ZONE },
  { id: 'Terrain_Petanque', name: 'Terrain pétanque', type: LocationType.COMMON_ZONE },
  { id: 'Location_Velo', name: 'Location vélo', type: LocationType.EQUIPMENT },

  // --- Équipements spécifiques ---
  { id: 'BBQ_Lodge', name: 'Barbecues lodge', type: LocationType.EQUIPMENT },
  { id: 'BBQ_Laverie', name: 'Barbecues laverie', type: LocationType.EQUIPMENT },
  { id: 'BBQ_Cottage', name: 'Barbecues espace cottage', type: LocationType.EQUIPMENT },
  { id: 'BBQ_Jeux', name: 'Barbecues aire de jeux', type: LocationType.EQUIPMENT },
  { id: 'Poubelle_M', name: 'Local poubelles M', type: LocationType.EQUIPMENT },
  { id: 'Poubelle_Cottage', name: 'Local poubelles espace cottage', type: LocationType.EQUIPMENT },
  { id: 'Poubelle_Accueil', name: 'Local poubelles accueil', type: LocationType.EQUIPMENT },

  // --- Locatifs - Zone B ---
  ...['B210', 'B209', 'B208', 'B207', 'B206', 'B306', 'B305', 'B304', 'B303'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: id.startsWith('B2') ? 'Zone B2' : 'Zone B3' })),

  // --- Locatifs - Box ---
  ...['Box1', 'Box2', 'Box3', 'Box4', 'Box5'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Box' })),

  // --- Locatifs - Zone C ---
  ...['C1', 'C2', 'C3', 'C4'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone C' })),

  // --- Locatifs - Zone H ---
  ...['H009', 'H010', 'H016', 'H017', 'H018'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone H' })),

  // --- Locatifs - Zone J ---
  ...['J019', 'J020', 'J021', 'J022', 'J023', 'J032', 'J033', 'J034', 'J035', 'J036'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone J' })),

  // --- Locatifs - Zone P ---
  ...['P048', 'P049', 'P050'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone P' })),

  // --- Locatifs - Zone V ---
  ...['V1', 'V5', 'V6', 'V7', 'V8', 'V9', 'V10'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone V' })),

  // --- Locatifs - Zone T ---
  ...['T5', 'T6'].map(id => ({ id, name: id, type: LocationType.LOCATIF, zone: 'Zone T' })),
]

export const MOCK_TEAMS = [
  'Équipe ménage',
  'Équipe technique',
  'Réception',
  'Responsable site',
]

export const MOCK_EMPLOYEES = [
  { id: 'VL', name: 'Vanessa Livet', role: 'Ménage' },
  { id: 'HH', name: 'Hans Hagen', role: 'Technique' },
  { id: 'SC', name: 'Saul Cardenas', role: 'Technique' },
  { id: 'LT', name: 'Lucie / Titouan', role: 'Ménage' },
]

export const INITIAL_TICKETS = [
  {
    id: '0',
    label: 'Fuite gaz Piscine',
    locationId: 'Piscine',
    assignedTo: { type: 'team', id: 'Équipe technique', name: 'Équipe technique' },
    status: Status.TODO,
    urgency: Urgency.CRITICAL,
    description: 'Odeur forte de gaz détectée dans le local technique piscine — zone fermée en attente d\'intervention',
    createdAt: new Date().toISOString(),
    createdBy: 'Responsable site',
    type: 'Technique',
    isCustomerRequest: false,
    history: [
      {
        id: 'h0a',
        type: 'creation',
        user: 'Responsable site',
        timestamp: new Date().toISOString(),
        details: 'Ticket créé en urgence suite à signalement campeur'
      }
    ]
  },
  {
    id: '1',
    label: 'Réparation WC',
    locationId: 'B210',
    assignedTo: { type: 'team', id: 'Équipe technique', name: 'Équipe technique' },
    status: Status.TODO,
    urgency: Urgency.IMPORTANT,
    description: 'Fuite au WC, chasse d\'eau faible',
    createdAt: new Date().toISOString(),
    createdBy: 'Système',
    type: 'Technique',
  },
  {
    id: '2',
    label: 'Électricité Accueil',
    locationId: 'Accueil',
    assignedTo: { type: 'team', id: 'Équipe technique', name: 'Équipe technique' },
    status: Status.IN_PROGRESS,
    urgency: Urgency.IMPORTANT,
    description: 'Spots qui clignotent + tache d\'humidité plafond',
    createdAt: new Date().toISOString(),
    createdBy: 'Admin',
    type: 'Technique',
  },
  {
    id: '3',
    label: 'Ménage déshivernage',
    locationId: 'H018',
    assignedTo: { type: 'team', id: 'Équipe ménage', name: 'Équipe ménage' },
    status: Status.TODO,
    urgency: Urgency.NORMAL,
    createdAt: new Date().toISOString(),
    createdBy: 'Réception',
    type: 'Ménage',
  },
  {
    id: '4',
    label: 'Calage Mobil-home',
    locationId: 'J036',
    assignedTo: { type: 'team', id: 'Équipe technique', name: 'Équipe technique' },
    status: Status.TODO,
    urgency: Urgency.NORMAL,
    description: 'Revoir calage du mobil-home',
    createdAt: new Date().toISOString(),
    createdBy: 'Technique',
    type: 'Technique',
  },
  {
    id: '5',
    label: 'Buse Jacuzzi',
    locationId: 'V9',
    assignedTo: { type: 'team', id: 'Équipe technique', name: 'Équipe technique' },
    status: Status.TODO,
    urgency: Urgency.NORMAL,
    description: 'Buse jacuzzi mal fixée',
    createdAt: new Date().toISOString(),
    createdBy: 'Système',
    type: 'Technique',
  },
]

export const INTERVENTION_CATEGORIES = [
  'Accompagnement / Placement client',
  'Administratif',
  'Animation',
  'Conciergerie / Service client',
  'Divers / Autres',
  'Électricité',
  'Entretien Général',
  'Gaz',
  'Inventaire',
  'Jardinage / Espaces vert',
  'Livraison / Récupération',
  'Mécanique',
  'Ménage',
  'Mobilier',
  'Peinture / Revêtements',
  'Plomberie',
  'Relevés',
  'Réunion',
  'Sécurité',
  'Structure'
]

export const EQUIPMENTS = [
  'Toboggan aquatique',
  'Cheminée / Pôle',
  'Hifi / Vidéo / Lumière PRO',
  'Equipement sportif (Cyti stade, ping pong...)',
  'Spa (Jacuzzi)',
  'Saulna / Hammam',
  'WIFI / Connexion / Téléphonie',
  'Manèges',
  'Mobilier extérieur',
  'Piscine',
  'Mobilier interieur',
  'Literie',
  'Equipement de loisir (Arcade, Flipper, Baby foot, consoles..)',
  'Aspirateur / Machine nettoyage PRO',
  'Tiny House',
  'Lodge Equipement Emplacement Tente (sanitaires, cusine, etc...)',
  'Arbres',
  'Compteur électrique',
  'Compteur gaz',
  'Compteur PH',
  'Compteur poids / Balance',
  'Compteur KM',
  'Compteur Eau',
  'Compteur Température / Thermomètre',
  'Vaisselle',
  'Chauffage / Chaudière',
  'Climatiseur',
  'Terrasse / Pergola',
  'Pompe',
  'Recharge Voiture Electrique',
  'Vélos / Trotinnettes',
  'Vélo Electrique',
  'Terrain de Pétanque',
  'Mur Escalade',
  'Compteur Chlore',
  'Barrière',
  'Fontaine Distributeur Eau',
  'Tente',
  'Tente +',
  'Solaire ( Panneaux / Chauffage)',
  'Poste de Secours',
  'Local technique',
  'Scène / Estrade',
  'Tracteurs ( matériel agricole)',
  'Tableau Electrique',
  'Borne de Distribution (Raccordement eau / elec)',
  'Puit',
  'Trappe, évacuation, regard',
  'Hifi / Vidéo',
  'Informatique',
  'Ventilateur',
  'Box Equestre',
  'Charrette enfant'
]
